import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  wrapper: {
    // width: '100%',
    position: 'static'
  },
  selectRoot: {
    // width: '100%',
    padding: '10px 24px 9px 10px',
    color: '#000',
    '&:focus': {
      backgroundColor: 'transparent'
    }
  },
  selectRootDisabled: {
    color: 'rgba(0, 0, 0, 0.38)',
    border: '0 !important'
  },
  label: {
    marginBottom: 6,
    color: '#071B27',
    textTransform: 'uppercase',
    fontSize: 10,
    lineHeight: '12px',
    letterSpacing: '0.035em',
    position: 'static',
    transform: 'none',

    '&.Mui-focused': {
      color: '#071B27'
    }
  },
  inputRoot: {
    // width: '100%',
    border: '1px solid #BECEDA',
    borderRadius: '3px',
    color: '#838383',
    fontSize: '13px',
    '&:hover': {
      border: '1px solid #41B7D7'
    }
  },
  inputRootDisabled: {
    border: '1px solid #BECEDA',
    '&:hover': {
      border: '1px solid #BECEDA'
    }
  },
  menuList: {
    border: '1px solid #F0F0F0',
    padding: '0',
    minWidth: '140px',
    boxShadow: '1px 2px 15px rgba(0,0,0, 0.08)',
    borderRadius: '4px'
  },
  menuItemRoot: {
    color: '#666666',
    '&:hover': {
      color: '#000000'
    }
  },
  error: {
    boxShadow: 'none',
    border: '1px solid #EB5757',
    '&:hover': {
      border: '1px solid #EB5757'
    }
  },
  disabledMenuItem: {
    display: 'none'
  }
});
